import LS from '../utils/localStorageHelpers'
const itemsConfigKey = 'itemsConfig'
export default {
  methods: {
    handleChangeFieldFilter() {
      console.log('handleChangeFieldFilter', this)
      this.$nextTick(() => {
        console.log('111111111111111')
        LS.setItem(itemsConfigKey, this.fields)
      })
    },
  },
}